import React from 'react';
import { Reveal } from './Reveal';
import { Counter } from './Counter';
import { metrics } from '../data/site';
export function MetricsSection() {
  return <section className="border-y border-charcoal/[0.08] bg-ivorydeep/60 px-6 py-24 sm:px-10 sm:py-32" data-id="element-95" data-mp="39v0if5r5dqqc">
      <div className="mx-auto max-w-[92rem]" data-id="element-96" data-mp="34vnwcn83onot">
        <Reveal data-id="element-97" data-mp="2zvja0gkigyqo">
          <p className="eyebrow text-mocha" data-id="element-98" data-mp="2zw1fm3t2cpb9">Impact to date</p>
        </Reveal>
        <dl className="mt-14 grid grid-cols-2 gap-x-8 gap-y-14 sm:gap-y-16 lg:grid-cols-5" data-id="element-99" data-mp="1ddtb62n7kyn">
          {metrics.map((m, i) => <Reveal key={m.label} delay={i * 0.08} data-id="element-100" data-mp="3sjx9l0r9034c" data-mpi={i}>
              <div className="border-t border-charcoal/15 pt-6" data-id="element-101" data-mp="3ns6wwo4u939r">
                <dd className="font-serif text-[3rem] font-light leading-none tracking-[-0.02em] text-charcoal sm:text-[4rem]" data-id="element-102" data-mp="3nqm5h7dtm0g4">
                  <Counter value={m.value} prefix={m.prefix} suffix={m.suffix} data-id="element-103" data-mp="k3c2jpi6fk3v" />
                </dd>
                <dt className="mt-4 text-[0.75rem] uppercase tracking-[0.16em] text-charcoal/50" data-id="element-104" data-mp="fcdh6bibzvtr">
                  {m.label}
                </dt>
              </div>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}